import { Link } from 'gatsby';
import { EuiButton, EuiSpacer } from '@elastic/eui';
import { OutboundLink } from 'gatsby-plugin-gtag';
import YoutubeVideo from "components/Internet_Access/The_DDNS_Service/YoutubeVideoCardRemote";
import PrimaryBox from "components/Internet_Access/The_DDNS_Service/PrimaryBox";
import DangerBox from "components/Internet_Access/The_DDNS_Service/DangerBox";
import ConfigTable from "components/Internet_Access/The_DDNS_Service/ConfigTable";
import NavButtons from 'components/Internet_Access/NavButtons';
import ForumBox from 'components/Internet_Access/The_DDNS_Service/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiButton,
  EuiSpacer,
  OutboundLink,
  YoutubeVideo,
  PrimaryBox,
  DangerBox,
  ConfigTable,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};